const initials = 'coupon/';

export const VALIDATE_COUPON_REQUEST = `${initials}VALIDATE_COUPON_REQUEST`;
export const VALIDATE_COUPON_SUCCESS = `${initials}VALIDATE_COUPON_SUCCESS`;
export const VALIDATE_COUPON_FAILURE = `${initials}VALIDATE_COUPON_FAILURE`;
export const CLEAR_VALIDATED_COUPON = `${initials}CLEAR_VALIDATED_COUPON`;
